export default {
  searchPlaceholder: 'Suche',
  titleLabel: 'Titel:'
};



// WEBPACK FOOTER //
// ./public/js/resources/de/main.js